// extracted by mini-css-extract-plugin
export default {"MapContainer":"MapContainer_MapContainer__uuiDo"};